import { useIntl } from 'react-intl';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from '../messages';
import style from './wwex-sub-view-footer.module.css';

type WwexSubViewFooterProps = {
  isDisabled?: boolean;
  isSaveDisabled?: boolean;
  onBack: () => void;
  onCancel: () => void;
  onSave: () => void;
};

export const WwexSubViewFooter = ({ isDisabled = false, isSaveDisabled = false, onBack, onCancel, onSave }: WwexSubViewFooterProps) => {
  const intl = useIntl();

  return (
    <FlexRow className={style.footerRow} gap={Gap.Space12}>
      <Button ariaLabel={intl.formatMessage(messages.backButton)} disabled={isDisabled} onClick={onBack} theme={THEME_CONSTANTS.link}>
        <FlexRow gap={Gap.Space8}>
          <FontAwesomeIcon icon={faChevronLeft} />
          {intl.formatMessage(messages.backButton)}
        </FlexRow>
      </Button>
      <FlexRow gap={Gap.Space12}>
        <Button
          ariaLabel={intl.formatMessage(messages.cancelButton)}
          disabled={isDisabled}
          onClick={onCancel}
          theme={THEME_CONSTANTS.white}
        >
          {intl.formatMessage(messages.cancelButton)}
        </Button>
        <Button
          ariaLabel={intl.formatMessage(messages.saveButton)}
          disabled={isDisabled || isSaveDisabled}
          onClick={onSave}
          theme={THEME_CONSTANTS.primary}
        >
          {intl.formatMessage(messages.saveButton)}
        </Button>
      </FlexRow>
    </FlexRow>
  );
};
